import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SYSTEM_HEALTH_COPY } from '../../constants/system-health.copy';
import { DisplayState } from '../../types/display-state.enum';

/** State conveyed by dot + text + colour, never colour alone. */
@Component({
  selector: 'fv-status-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="pill" [class]="'pill--' + state()">
      <span class="pill__dot" aria-hidden="true"></span>
      {{ label() }}
    </span>
  `,
  styleUrl: './status-pill.component.scss',
})
export class StatusPillComponent {
  readonly state = input.required<DisplayState>();
  readonly label = computed(() => SYSTEM_HEALTH_COPY.states[this.state()]);
}
